import React from 'react'
import styles from '../../styles/common/FractionPreviewText.module.scss'

interface FractionPreviewTextProps {
  text: string
}

const FractionPreviewText: React.FC<FractionPreviewTextProps> = ({ text }) => {
  const parts = text.split(/(\d+\s\d+\/\d+|\d+\/\d+)/g)

  return (
    <>
      {parts.map((part, index) => {
        const mixedMatch = part.match(/^(\d+)\s(\d+)\/(\d+)$/)
        if (mixedMatch) {
          const [, whole, numerator, denominator] = mixedMatch
          return (
            <span key={index} className={styles.mixedFraction}>
              <span className={styles.fractionWhole}>{whole}</span>
              <span className={styles.fractionPart}>
                <span className={styles.fractionNumerator}>{numerator}</span>
                <span className={styles.fractionBar}></span>
                <span className={styles.fractionDenominator}>
                  {denominator}
                </span>
              </span>
            </span>
          )
        }

        const fractionMatch = part.match(/^(\d+)\/(\d+)$/)
        if (fractionMatch) {
          const [, numerator, denominator] = fractionMatch
          return (
            <span key={index} className={styles.inlineFraction}>
              <span className={styles.fractionNumerator}>{numerator}</span>
              <span className={styles.fractionBar}></span>
              <span className={styles.fractionDenominator}>{denominator}</span>
            </span>
          )
        }

        return <span key={index}>{part}</span>
      })}
    </>
  )
}

export default FractionPreviewText